import React from 'react';
import {ModelContext} from "./ModelContext";

const ModelProvider = ({model, ...props}) => {
    return <ModelContext.Provider value={model} {...props} />;
};

export default ModelProvider;